import MapSpinner from "./MapSpinner.jsx"

export default MapSpinner